const Config = {
    authServerUrl: process.env.REACT_APP_SANDBOX_MGR_API_URL
}

export default Config;